import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=6fdf4462&scoped=true&"
import script from "./ChannelSelector.vue?vue&type=script&lang=js&"
export * from "./ChannelSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSelector.vue?vue&type=style&index=0&id=6fdf4462&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf4462",
  null
  
)

export default component.exports